import React, { Component } from "react";
import { connect } from "dva";
import Container from "@/components/Container";
import Iframe from "@/components/Iframe";
import { NEW_RDP_PUBLIC_URL } from "@/utils/utils";

@connect(({ user }) => ({
  ...user
}))
class Patrol extends Component {
  render() {
    const { currentUser } = this.props;
    const { orgId, enOrgType } = currentUser;

    if (!orgId) {
      return null;
    }

    const IframeDom = Iframe({
      src: `${NEW_RDP_PUBLIC_URL}/${enOrgType === "general_school" ? 'c38c9c8fb6404ece7483f00f5478de76' : '18a3c1592e17f2cb87cc75b38cb90a8b'}?orgId=${orgId}`
    });

    return (
      <Container breStates>
        <IframeDom />
      </Container>
    );
  }
}

export default Patrol;
